angular.module("app").controller("ErrorModalController", ErrorModalController);

ErrorModalController.$inject = ['config', '$uibModalInstance'];

function ErrorModalController(config, $modalInstance) {
    var vm = this;
    vm.header = config.header;
    vm.content1 = config.content1;
    vm.content2 = config.content2;
    vm.content3 = config.content3;
    vm.isLock = config.isLock;

    vm.close = close;

    function close() {
        $modalInstance.close();
    }
}